module.exports = __webpack_public_path__ + "static/media/comercio_cordoba.c405977b.jpg";